/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { classNames } from '#utils/UNSAFE_classNames';
import { sparkleStyles } from './themes/List.css';

/**
 * A sparkle component for smart suggestion indicator in TableList
 * @param sparkleHeight the height of sparkle
 */
export function Sparkle() {
  const sparkleClasses = classNames([sparkleStyles.base]);

  return <div class={sparkleClasses} />;
}
